import "./CouraselStyles.css"
import { useState } from "react";
import Slider from "react-slick";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";

import IMG_01 from '../Assets/IMG-002.png';
import IMG_02 from '../Assets/IMG-003.png';
import IMG_03 from '../Assets/IMG-007.png';
import IMG_04 from '../Assets/IMG-001.png';
import IMG_05 from '../Assets/IMG-005.png';
import IMG_06 from '../Assets/IMG-004.png';
import IMG_07 from '../Assets/IMG-006.png';



const images = [IMG_01, IMG_02, IMG_03, IMG_04, IMG_05, IMG_06, 
    IMG_07, 
]
function Courasel(){
    const NextArrow = ({ onClick }) => {
        return(
            <div className="arrow next" onClick={onClick}>
                <FaArrowRight/>
            </div>
        );
    };

    const PrevArrow = ({ onClick }) => {
        return (
            <div className="arrow prev" onClick={onClick}>
                <FaArrowLeft/>
            </div>
        );
    };

    const [imageIndex, setImageIndex] = useState(0);

    const settings = {
        infinite : true,
        lazyLoad: true,
        speed: 300,
        slidesToShow: 5,
        centerMode:true,
        autoplay: true,       // Enable auto-slide
        autoplaySpeed: 1500,  // Change slides every 3 seconds
        centerPadding:0,
        nextArrow: <NextArrow/>,
        prevArrow: <PrevArrow/>,
        beforeChange: (current, next) => setImageIndex(next),
        responsive: [
            {
                breakpoint: 1024, // Tablets and medium screens
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768, // Smaller tablets and landscape phones
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480, // Mobile devices
                settings: {
                    slidesToShow: 1, // Show only 1 slide on small screens
                    centerMode: false, // Disable center mode on mobile
                },
            },
        ],
    };

    return (
        <div className="Courasel">
            <div className="Header-c">
        <div className="heading">
        <h4>Our Partners </h4>
        <p> At Multishade Insurance, we take pride in collaborating with industry leaders and trusted partners 
  who share our vision of providing comprehensive financial security. Our partners include top 
  professionals in finance, risk management, and customer support, ensuring that we deliver 
  reliable and innovative insurance solutions tailored to your needs.</p>

        </div>
        </div>
            <Slider {...settings}>
                {images.map((img, idx) => (
                    <div className={idx === imageIndex ? "slide activeSlide" : "slide"}>
                        <img src={img} alt="img" />
                    </div>
                    
                ))}
            </Slider>
        </div>
    );
}

export default Courasel;